import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Styles from "./css/footerlinks.module.scss";
import { isChrome, isFirefox, isIeEdge } from "@tightrope/lpscripts/browserdetect";
let RawFooter = /*#__PURE__*/function (_React$Component) {
  function RawFooter(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      data: {},
      language: {}
    };
    return _this;
  }
  _inheritsLoose(RawFooter, _React$Component);
  var _proto = RawFooter.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props && this.props.data) {
      this.props.data.then(data => {
        this.setState({
          data: data
        });
        this.setState({
          language: this.props.language
        });
      });
    }
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("footer", {
      id: Styles.footer
    }, (() => {
      switch (this.props.language) {
        case 'de':
          return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Tightrope Interactive"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Bedingungen")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Datenschutz")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/uninstall/",
            target: "_blank"
          }, "Deinstallieren")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/unsubscribe/",
            target: "_blank"
          }, "Abbestellen")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/contact-us/",
            target: "_blank"
          }, "Kontakt")), /*#__PURE__*/React.createElement("li", null, "Warenzeichen sind Eigentum ihrer jeweiligen Inhaber"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/do-not-sell-info/",
            target: "_blank"
          }, "Verkaufen Sie meine pers\xF6nlichen Daten nicht")));
          break;
        case 'fr':
          return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Tightrope Interactive"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termes")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Confidentialit\xE9")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/uninstall/",
            target: "_blank"
          }, "D\xE9sinstaller")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/unsubscribe/",
            target: "_blank"
          }, "Se d\xE9sabonner")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/contact-us/",
            target: "_blank"
          }, "Contact")), /*#__PURE__*/React.createElement("li", null, "Toutes les marques sont la propri\xE9t\xE9 de leurs propri\xE9taires respectifs"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/do-not-sell-info/",
            target: "_blank"
          }, "Ne vendez pas mes informations personnelles")));
          break;
        case 'it':
          return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Tightrope Interactive"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termini e Condizioni")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Disintalla")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/uninstall/",
            target: "_blank"
          }, "D\xE9sinstaller")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/unsubscribe/",
            target: "_blank"
          }, "Cancella Iscrizione")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/contact-us/",
            target: "_blank"
          }, "Contatti")), /*#__PURE__*/React.createElement("li", null, "Tutti i marchi sono di propriet\xE0 dei rispettivi proprietari"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/do-not-sell-info/",
            target: "_blank"
          }, "Non Vendere le Mie Informazioni Personali")));
          break;
        case 'bz':
          return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Tightrope Interactive"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termos")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Pol\xEDtica de Privacidade")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/uninstall/",
            target: "_blank"
          }, "Desinstalar")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/unsubscribe/",
            target: "_blank"
          }, "Cancelar")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/contact-us/",
            target: "_blank"
          }, "Contato")), /*#__PURE__*/React.createElement("li", null, "Todas as marcas registradas s\xE3o de propriedade de seus respectivos propriet\xE1rios"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/do-not-sell-info/",
            target: "_blank"
          }, "N\xE3o venda minhas informa\xE7\xF5es pessoais")));
          break;
        case 'clear':
          return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Tightrope Interactive"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/terms-of-service/",
            target: "_blank"
          }, "Terms")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/privacy-policy/",
            target: "_blank"
          }, "Privacy")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/uninstall/",
            target: "_blank"
          }, "Uninstall")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/unsubscribe/",
            target: "_blank"
          }, "Unsubscribe")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/contact-us/",
            target: "_blank"
          }, "Contact")), /*#__PURE__*/React.createElement("li", null, "All trademarks are property of their respective owners"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/privacy-policy/#cali-consumer",
            target: "_blank"
          }, "Do Not Sell My Personal Information")));
          break;
        default:
          return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Tightrope Interactive"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Terms")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Privacy")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/uninstall/",
            target: "_blank"
          }, "Uninstall")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/unsubscribe/",
            target: "_blank"
          }, "Unsubscribe")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/contact-us/",
            target: "_blank"
          }, "Contact")), /*#__PURE__*/React.createElement("li", null, "All trademarks are property of their respective owners"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
            href: "/do-not-sell-info/",
            target: "_blank"
          }, "Do Not Sell My Personal Information")));
      }
    })());
  };
  return RawFooter;
}(React.Component);
export default RawFooter;